import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgImage from '../images/background.png';

const MEMBERS = [
    { id: 1, username: 'Diego',       gang: 'Fumets',    month: 24, average: 3.5, wines: 4  },
    { id: 2, username: 'Javierdelah', gang: 'Fumets',    month: 22, average: 3.6, wines: 8  },
    { id: 3, username: 'Lucas',       gang: 'Aguiluchos',month: 56, average: 4.2, wines: 12 },
    { id: 4, username: 'Carolina',    gang: 'Llamas',    month: 89, average: 2.8, wines: 16 },
    { id: 5, username: 'Pedro',       gang: 'Dragones',  month: 37, average: 4.0, wines: 20 },
];
const MEDAL = ['#d4a017', '#9baab5', '#c47b32'];

function LdIcon({ name, size = 20 }) {
    const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (name) {
        case 'back':   return <svg {...p}><path d="M19 12H5M12 19l-7-7 7-7"/></svg>;
        case 'shield': return <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
        case 'invite': return <svg {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>;
        case 'inbox':  return <svg {...p}><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>;
        case 'kick':   return <svg {...p}><path d="M18 6 6 18M6 6l12 12"/></svg>;
        default: return null;
    }
}

export default function Lider() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [ready, setReady] = useState(false);

    useEffect(() => { requestAnimationFrame(() => setReady(true)); }, []);

    return (
        <div className={`ug-stage${ready ? ' ug-ready' : ''}`}>
            <div className="ug-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="ug-vignette" />
            <div className="ug-grain" />

            <div className="ug-header">
                <button className="gn-back-btn" onClick={() => navigate(-1)} aria-label={t('common.back')}>
                    <LdIcon name="back" size={18} />
                </button>
                <div className="ug-header-brand">
                    <LdIcon name="shield" size={14} />
                </div>
                <div style={{ width: 40 }} />
            </div>

            <div className="ug-identity">
                <h1 className="ug-gang-name">Fumets</h1>
                <p className="ug-gang-desc">{t('gangs.leader_demo_desc')}</p>
            </div>

            <div className="ug-actions-bar">
                <button className="ug-action-btn ug-action-invite" onClick={() => navigate('/gangs/invitar')}>
                    <LdIcon name="invite" size={14} /><span>{t('gangs.invite')}</span>
                </button>
                <button className="ug-action-btn ug-action-requests" onClick={() => navigate('/gangs/solicitudes')}>
                    <LdIcon name="inbox" size={14} /><span>{t('gangs.requests')}</span>
                </button>
            </div>

            <div className="ug-panel">
                <div className="rk-table">
                    <div className="rk-thead rk-thead-kick">
                        <span>{t('common.position')}</span>
                        <span>{t('common.name')}</span>
                        <span>{t('common.month')}</span>
                        <span>{t('common.average')}</span>
                        <span>{t('common.wines')}</span>
                        <span>{t('gangs.kick')}</span>
                    </div>
                    <div className="rk-tbody">
                        {MEMBERS.map((user, i) => (
                            <div
                                key={user.id}
                                className={`rk-row rk-row-kick${i < 3 ? ' rk-row-top' : ''}`}
                                style={{ animationDelay: `${i * 0.04}s` }}
                            >
                                <span className="rk-pos">
                                    {i < 3 && <span className="rk-medal-dot" style={{ background: MEDAL[i] }} />}
                                    {i + 1}
                                </span>
                                <span className="rk-username">{user.username}</span>
                                <span className="rk-val">{user.month}</span>
                                <span className="rk-val">{user.average.toFixed(1)}%</span>
                                <span className="rk-val">{user.wines}</span>
                                <button className="ug-kick-btn" aria-label={t('gangs.kick')}>
                                    <LdIcon name="kick" size={13} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
